import React from "react";

const TwitterIcon = props => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>twitter</title>
    <desc>Created with Sketch.</desc>
    <defs />
    <g
      id="twitter"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="iconmonstr-twitter-1"
        transform="translate(0.000000, 2.000000)"
        fill="#363636"
        fillRule="nonzero"
      >
        <path
          d="M24,2.557 C23.117,2.949 22.168,3.213 21.172,3.332 C22.189,2.723 22.97,1.758 23.337,0.608 C22.386,1.172 21.332,1.582 20.21,1.803 C19.313,0.846 18.032,0.248 16.616,0.248 C13.437,0.248 11.101,3.214 11.819,6.293 C7.728,6.088 4.1,4.128 1.671,1.149 C0.381,3.362 1.002,6.257 3.194,7.723 C2.388,7.697 1.628,7.476 0.965,7.107 C0.911,9.388 2.546,11.522 4.914,11.997 C4.221,12.185 3.462,12.229 2.69,12.081 C3.316,14.037 5.134,15.46 7.29,15.5 C5.22,17.123 2.612,17.848 -1.77635684e-15,17.54 C2.179,18.937 4.768,19.752 7.548,19.752 C16.69,19.752 21.855,12.031 21.543,5.106 C22.505,4.411 23.34,3.544 24,2.557 Z"
          id="Shape"
        />
      </g>
    </g>
  </svg>
);

export default TwitterIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/TwitterIcon.js